import { authenticationService } from "@/core/services";
import { usersMeRetrieve } from "@sgdf/client";
import { apiCall } from "@/core/utils/api";
import type { NotNestedMeetingRole } from "@sgdf/client";
import { useQuery } from "@tanstack/vue-query";

export const useMe = () => {
  const userStore = useUserStore();
  const { meId } = storeToRefs(userStore);

  if (!meId.value) {
    authenticationService.getUser().then((user) => {
      if (user?.id) {
        userStore.setMeId(user.id);
      }
    });
  }

  return meId;
};

export const useMeDetails = () => {
  return useQuery({
    queryKey: ["me"],
    queryFn: () => apiCall(usersMeRetrieve()),
    staleTime: Infinity,
  });
};

export interface UserRole {
  isDirector: boolean;
  isFormer: boolean;
  isIntern: boolean;
  isSuperuser: boolean;
  detail: NotNestedMeetingRole | null;
}

export const useMyParticipation = () => {
  const meetingId = useMeetingId();
  const { data, refetch: internalRefetch, ...rest } = useMeDetails();
  const participation = computed(() => {
    if (meetingId.value && data.value && data.value.participations) {
      return data.value.participations.find(
        (p) => p.meeting === meetingId.value,
      );
    }
  });

  const diplomas = computed(() => data.value?.diplomas);
  const isLoading = computed(() => rest.isLoading.value);

  const refetch = async () => {
    const { data: internalData, ...refetchRest } = await internalRefetch();

    if (meetingId.value && internalData && internalData.participations) {
      const currentParticipation = internalData.participations.find(
        (p) => p.meeting === meetingId.value,
      );
      return {
        participation: currentParticipation,
        diplomas: internalData.diplomas,
        ...refetchRest,
      };
    }
  };

  return {
    participation,
    refetch,
    diplomas,
    ...rest,
    isLoading,
  };
};

export const isUserAMeetingParticipant = () => {
  const curParticipation = useMyParticipation();

  return computed(() => !!curParticipation.participation.value);
};
